{
  "name": "@lark-apaas/observable",
  "version": "1.0.6",
  "description": "Observable SDK",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "plugin",
    "server",
    "typescript"
  ],
  "engines": {
    "node": ">=18.0.0"
  },
  "files": [
    "dist"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "echo 'ESLint skipped for TypeScript files'",
    "lint:fix": "eslint src --ext .ts --fix"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/api-logs": "^0.208.0",
    "@opentelemetry/core": "^2.2.0",
    "@opentelemetry/resources": "^2.2.0",
    "@opentelemetry/sdk-logs": "^0.208.0",
    "@opentelemetry/sdk-node": "^0.208.0",
    "@opentelemetry/sdk-trace-node": "^2.2.0"
  },
  "devDependencies": {
    "tsup": "^8.0.0",
    "typescript": "^5.2.0"
  }
}
